import { useCallback, useContext } from 'react'
import { Grid } from '@mui/material';
import AccordionPanel from 'view/FrontEnd/Project/components/AccordionPanel';
import { ProviderExpensePlan } from './FundExpensesPlanForm';
import TableInputTotal from './TableInputTotal';
import TableExpenseSectionProject from './TableExpenseSectionProject';
import TableHookForm from './TableHookForm';
import TableExpenseSummary from './TableExpenseSummary';
import TableHookFormVersion from './TableHookFormVersion';

const TableExpenseSection = () => {
    const {
        lstExpense,
        lstExpenseVersion,
        isVersion
    } = useContext(ProviderExpensePlan);

    const callbackChangeVersion =useCallback(()=>{
        return(
            <>
                {
                    isVersion ?
                        <RenderListExpense
                            keyId={"V_"}
                            lstData={lstExpenseVersion}
                            isVersion={true}
                        />
                        :
                        <RenderListExpense
                            keyId={"I_"}
                            lstData={lstExpense}
                            isVersion={false}
                        />
                }
            </>
        )
    },[isVersion, lstExpense, lstExpenseVersion])

    return (
        <Grid container spacing={2}>
            {callbackChangeVersion()}
            <Grid item xs={12}>
                <TableExpenseSummary keyId={"T_"} />
            </Grid>
        </Grid>
    )
}

export default TableExpenseSection

const RenderListExpense = ({ lstData, keyId, isVersion }) => {
    return (
        <>
            {
                lstData.map((item, indexSection) => {
                    let keyCellMuseum = keyId + "_Id" + item.nSectionId + "_idx" + indexSection;
                    return (
                        <Grid key={keyCellMuseum} item xs={12}>
                            <AccordionPanel header={item.sSectionName} >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TableInputTotal
                                            keyCellMuseum={keyCellMuseum}
                                            item={item}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {
                                            item.nSectionId === 39 ?
                                                <TableExpenseFundOnAdd isVersion={isVersion} />
                                                :
                                                <TableExpenseSectionProject keyId={keyId} item={item} isVersion={isVersion}/>
                                        }
                                    </Grid>
                                </Grid>
                            </AccordionPanel>
                        </Grid>
                    )
                })
            }
        </>
    )
}

const TableExpenseFundOnAdd = ({ isVersion }) => {
    return (
        <>
            {
                isVersion ?
                    <TableHookFormVersion keyId={"nested_"} />
                    :
                    <TableHookForm keyId={"nested_"} />
            }
        </>
    )
}
